module.exports = __webpack_public_path__ + "img/brightsword.f8bebe63.png";